import React from 'react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { DISCLOSURE_FILTERS, matchesDisclosureFilter, type DisclosureId } from '../../data/disclosures';
interface DisclosureFilterBarProps {
  value: string;
  onChange: (filterId: string) => void;
  /** Every review in scope, used to compute per-filter counts. */
  items: {
    disclosures?: DisclosureId[];
  }[];
}

/**
 * Reader-facing disclosure filter.
 *
 * Two deliberate properties:
 *  - "All" is the default and INCLUDES paid, gifted and ARC reviews. Nothing is
 *    hidden by default; this is a lens for the reader, not a suppression tool.
 *  - Counts render even when zero, so a reader can see that (say) 3 of 40
 *    reviews are ARC copies. Hiding empty options would hide that fact.
 */
export const DisclosureFilterBar: React.FC<DisclosureFilterBarProps> = ({
  value,
  onChange,
  items
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const countFor = (filterId: string) => filterId === 'all' ? items.length : items.filter(item => matchesDisclosureFilter(item.disclosures, filterId)).length;
  return <div data-id="element-1488" data-mp="7icse9espk17">
      <div className="flex flex-wrap items-center gap-2" data-id="element-1489" data-mp="7jxk7r9q6ovd">
        <span className={`text-sm font-medium mr-1 ${dk.textSecondary}`} data-id="element-1490" data-mp="bkgedrz3c70q">
          Relationship:
        </span>
        {DISCLOSURE_FILTERS.map(filter => {
        const isActive = value === filter.id;
        const count = countFor(filter.id);
        return <button key={filter.id} onClick={() => onChange(filter.id)} aria-pressed={isActive} className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-full border min-h-[36px] transition-colors ${isActive ? `${rt.bgMedium} ${rt.textPrimary} border-current` : `${dk.surface} ${dk.textSecondary} ${dk.isDark ? 'border-gray-700' : 'border-gray-300'}`}`} data-id="element-1491" data-mp="3fyy1dq7fgd4b">
              {filter.label}
              <span className={`text-xs ${isActive ? '' : dk.textMuted}`} data-id="element-1492" data-mp="2wayfcvktnxbo">
                {count}
              </span>
            </button>;
      })}
      </div>
      <p className={`mt-2 text-xs ${dk.textMuted}`} data-id="element-1493" data-mp="3a8d8aaaaan8e">
        Paid, gifted and ARC reviews are always included in results. Disclosure
        does not affect a review's rating or position.
      </p>
    </div>;
};
export default DisclosureFilterBar;